
{
  "familyId": "GET-GROOT-SCHATTEN",
  "questions": [
    {
      "id": "GET-GROOT-SCHATTEN-001",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "Een school heeft 387 leerlingen. Hoeveel leerlingen zijn dat ongeveer?",
      "options": [
        "ongeveer 400",
        "ongeveer 300",
        "ongeveer 350",
        "ongeveer 500"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schatten_honderdtallen",
      "variantIndex": 1,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: rond af op het dichtstbijzijnde 'makkelijke' getal. Stap 1: 387 ligt tussen 300 en 400. Stap 2: 387 is dichter bij 400 (verschil 13) dan bij 300 (verschil 87). Stap 3: dus 387 ≈ 400.",
        "distractorExplanations": {
          "0": "Goed! 387 ligt het dichtst bij 400. Schatten = afronden op een handig getal.",
          "1": "300 is te laag. 387 is veel dichter bij 400 dan bij 300. Het verschil met 300 is 87, met 400 maar 13.",
          "2": "350 is niet verkeerd als schatting, maar 400 is nauwkeuriger. Bij schatten op honderdtallen kies je het dichtstbijzijnde honderdtal.",
          "3": "500 is te hoog. 387 ligt dichter bij 400 dan bij 500. Het verschil met 400 is 13, met 500 is het 113."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-002",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "Je wilt 48 × 21 schatten. Welke schatting is het handigst?",
      "options": [
        "50 × 20 = 1.000",
        "48 × 20 = 960",
        "40 × 20 = 800",
        "50 × 25 = 1.250"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schatten_vermenigvuldiging",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Strategie: rond beide getallen af naar 'makkelijke' getallen. Stap 1: 48 ≈ 50 (dichtbij, makkelijk getal). Stap 2: 21 ≈ 20 (dichtbij, makkelijk getal). Stap 3: 50 × 20 = 1.000. Het echte antwoord is 48 × 21 = 1.008, dus de schatting is heel nauwkeurig!",
        "distractorExplanations": {
          "0": "Goed! 50 × 20 = 1.000 is de handigste schatting. Beide getallen zijn afgerond naar het dichtstbijzijnde tiental.",
          "1": "48 × 20 = 960 is nauwkeurig, maar niet de handigste schatting. Bij schatten rond je beide getallen af naar makkelijke getallen.",
          "2": "40 × 20 = 800 is te laag. 48 is dichter bij 50 dan bij 40. Door te ver af te ronden wordt je schatting minder nauwkeurig.",
          "3": "50 × 25 = 1.250 is te hoog. 21 is dichter bij 20 dan bij 25. Rond af naar het dichtstbijzijnde tiental."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-003",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "In een stadion zitten 23.456 mensen. Hoeveel is dat afgerond op duizendtallen?",
      "options": [
        "23.000",
        "24.000",
        "23.500",
        "20.000"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schatten_duizendtallen",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: kijk naar het cijfer rechts van de duizendtallen. Stap 1: afronden op duizendtallen → kijk naar de honderdtallen (4). Stap 2: 4 < 5, dus afronden naar beneden. Stap 3: 23.456 ≈ 23.000.",
        "distractorExplanations": {
          "0": "Goed! Het honderdtallencijfer is 4 (< 5), dus naar beneden: 23.000.",
          "1": "Veelgemaakte fout: naar boven afronden. Het honderdtallencijfer is 4, en 4 < 5, dus naar beneden (23.000), niet naar boven (24.000).",
          "2": "23.500 is afgerond op honderdtallen, niet op duizendtallen. Bij duizendtallen worden honderdtallen, tientallen en eenheden 0.",
          "3": "20.000 is afgerond op tienduizendtallen, niet op duizendtallen. Dat is te grof afgerond."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-004",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "Je wilt 312 + 489 schatten. Welke schatting past het best?",
      "options": [
        "300 + 500 = 800",
        "300 + 400 = 700",
        "310 + 490 = 800",
        "350 + 500 = 850"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schatten_optelling",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Strategie: rond beide getallen af op honderdtallen. Stap 1: 312 ≈ 300 (naar beneden, want 1 < 5). Stap 2: 489 ≈ 500 (naar boven, want 8 ≥ 5). Stap 3: 300 + 500 = 800. Het echte antwoord is 801, dus de schatting is uitstekend!",
        "distractorExplanations": {
          "0": "Goed! 300 + 500 = 800 is de beste schatting. 312 ≈ 300 en 489 ≈ 500.",
          "1": "300 + 400 = 700 is te laag. 489 is dichter bij 500 dan bij 400 (het tientallencijfer 8 ≥ 5, dus naar boven).",
          "2": "310 + 490 = 800 geeft hetzelfde antwoord, maar is minder handig om uit het hoofd te rekenen. Bij schatten kies je de makkelijkste getallen.",
          "3": "350 + 500 = 850 is minder nauwkeurig. 312 is dichter bij 300 dan bij 350."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-005",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "Een boek heeft 196 pagina's. Je hebt er 52 gelezen. Hoeveel pagina's moet je nog ongeveer lezen?",
      "options": [
        "ongeveer 150",
        "ongeveer 100",
        "ongeveer 200",
        "ongeveer 250"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schatten_aftrekking_context",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Strategie: rond af en reken dan. Stap 1: 196 ≈ 200 (dichtbij, makkelijk getal). Stap 2: 52 ≈ 50 (dichtbij, makkelijk getal). Stap 3: 200 − 50 = 150. Je moet nog ongeveer 150 pagina's lezen. (Exact: 196 − 52 = 144.)",
        "distractorExplanations": {
          "0": "Goed! 200 − 50 = 150. De schatting is dicht bij het exacte antwoord (144).",
          "1": "100 is te laag. 196 − 52 is veel meer dan 100. Als je 200 − 50 rekent, krijg je 150.",
          "2": "200 is te hoog. Je hebt al 52 pagina's gelezen, dus je hoeft niet meer bijna het hele boek te lezen.",
          "3": "250 is te hoog. Het boek heeft maar 196 pagina's in totaal, dus je kunt nooit meer dan 196 pagina's over hebben."
        }
      }
    }
  ]
}
